import React, { useState } from 'react';

interface ImageWithFallbackProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  fallback?: string | string[];
}

const ImageWithFallback: React.FC<ImageWithFallbackProps> = ({
  src,
  alt,
  fallback = 'https://images.unsplash.com/photo-1504674900247-0877df9cc836', // 기본 음식 이미지
  ...props
}) => {
  // src가 null, undefined, 빈 문자열인 경우 즉시 fallback 사용
  const getInitialSrc = (): string => {
    if (!src || src.trim() === '') {
      return Array.isArray(fallback) ? fallback[0] : fallback;
    }
    return src;
  };

  const [imgSrc, setImgSrc] = useState<string>(getInitialSrc());
  const [fallbackIndex, setFallbackIndex] = useState<number>(0);

  const handleError = () => {
    // fallback이 배열인 경우 순차적으로 시도
    if (Array.isArray(fallback)) {
      if (fallbackIndex < fallback.length) {
        setImgSrc(fallback[fallbackIndex]);
        setFallbackIndex(prev => prev + 1);
      }
      // 모든 fallback 시도 완료 시 마지막 fallback 유지
    } else {
      // 단일 fallback인 경우 기존 로직 유지
      if (imgSrc !== fallback) {
        setImgSrc(fallback);
      }
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback; 